export default {
    page: function() {
        this.loadCustomersTrips()
    }
}
